import Starfleet from "./starfleet";

console.log(`Account Wrapper Starfleet v${APP_VERSION}`);

if (!window.NVIDIAGDC) {
    window.NVIDIAGDC = {};
}

window.NVIDIAGDC.starfleet = Starfleet;

//dispatch a custom event to document
document.dispatchEvent(new CustomEvent("starfleet-ready"));
